import React from 'react';
import "../PageCss/Contact.css";
import SideNavNewsEvents from '../components/SideNavNewsEvents';
import '../PageCss/SingaleProductPage.css';
import '../PageCss/NewsEvent.css';
import { useAappContext } from '../context/AppContext';
import { NavLink } from 'react-router-dom';

const ContactUs = () => {
const {Avansis} =useAappContext()
    return (
  <>
       <section id="newevent" className='section-m1 section-p1'>
        <div className="newevent">
          <div id='page-title' className="title-yellow">
           <span>Contact Us</span>
          </div>
          {
            Avansis.map((curElem)=>{
              return (
                <div key={curElem.id} className="caddress">
                <p><span>Add: </span> {curElem.address}</p>
                <p><span>Tel: </span> {curElem.mobaile}</p>
                <p><span>Email: </span> {curElem.email}</p>
                <p><span>Website </span>
                <NavLink to="https://www.avansisbd.com" target="_blank"> {curElem.webLink}</NavLink>
                </p>
                </div>
              )
            })
          }
         
          <div className="gmap">
        <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.6542719114173!2d89.99692158316624!3d23.86640750852453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fe1d6a7937d65f%3A0x74608b0d5f734f8!2z4KaT4Kav4Ka84KeN4Kav4Ka-4Kaw4Kay4KeH4Ka44KaX4KeH4Kaf!5e0!3m2!1sbn!2sbd!4v1741552298146!5m2!1sbn!2sbd" height="350" width="100%" allowFullScreen loading="lazy" eferrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        
     
        </div>
       
        <SideNavNewsEvents/>
     
      
    </section>
    <section id='casForm' className='section-m1 section-p1'>
      <div className="col-left">
          <h1>Getting in touch is easy</h1>
          <p>Curious to hear more about us? <br/>
            Don’t hesitate to fill out the contact form and get <br/>in touch
          </p>
      </div>
      <div className="col-right">
        <form className="input_box" action="https://formspree.io/f/mzzanokp" method="POST">
    <label>Subject
    <select name="selectSubject">
    <option selected="">Select Subject</option>
    <option value="Products">Products</option>
    <option value="Distributor">Distributor</option>
    <option value="Recruit">Recruit</option>
    <option value="Others">Others</option>
    </select>
    
</label>

<label>Country<input type="text" name="country2" /></label>
<label>First Name<input type="text" name="name1" /></label>
<label>Last Name<input type="text" name="name2" /></label>
<label>Company<input type="text" name="company2" /></label>
<label>E-Mail<input type="text" name="email2" /></label>
<label>Message<textarea name="message2"></textarea></label>
<button className='btn_contact'>Send Message</button>
</form>
</div>
    </section>

  </> 

)}

export default ContactUs